import { render, staticRenderFns } from "./addedServices.vue?vue&type=template&id=affdc192&"
import script from "./addedServices.vue?vue&type=script&lang=js&"
export * from "./addedServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports